import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CustomText, { textStyles } from "../CustomText";
import subcard from "../../assets/Settings/subcard.svg"
import { useTheme } from '../../contexts/ThemeContext';
const SettingCard = ({ icon, title, description }) => {
  const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor } = useTheme();
  
  return (
    <Box
      sx={{
        borderRadius: 3,
        border: `1px solid ${primaryColor}20`,
        px: 3,
        py:3,
        backgroundColor: "white",
        position: "relative",
        minHeight: 120,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border:"none",cursor:"pointer"

      }}
    >
      {/* Top Row */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1,
            backgroundColor: "#2F3B53",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={icon} alt="icon" style={{ width: 20, height: 20 }} />
        </Box>
    
        <Box>
            <img src={subcard}/>
        </Box>
      </Box>

      {/* Content */}
      <Box mt={1.5}>
        <CustomText 
          sx={{ 
            ...textStyles.h2, 
            fontWeight: 600, 
            mt: 1, 
            fontSize: "18px", 
            color: "#181818", 
            textAlign: "left",
            lineHeight: "24px"
          }}
        >
          {title}
        </CustomText>
      
        <CustomText 
          sx={{ 
            ...textStyles.h2, 
            fontWeight: 400, 
            fontFamily: 'Poppins, sans-serif',
            maxWidth: "300px", 
            fontSize: "14px", 
            pt: 1.3, 
            lineHeight: "20px", 
            color: "#5E5C5C", 
            textAlign: "left" 
          }}
        >
          {description}
        </CustomText>
      </Box>
    </Box>
  );
};

export default SettingCard;
